import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as RadixRadioGroup from '@radix-ui/react-radio-group';
import { useId } from 'react';
import { styled } from 'styletron-react';
import { CheckedIcon } from '../../../assets/CheckedIcon';
import { staticColors } from '../../../const/colors/staticColors';
import { sizes } from '../../../const/sizes';
import { useTestIdAttribute, } from '../../../hooks/useTestIdAttribute';
import { Text } from '../../Text/Text';
import { Box } from '../../layout/Box';
import { FlexContainer } from '../../layout/FlexContainer';
import { GridContainer } from '../../layout/GridContainer';
import { RadioDonutIndicator } from './components/RadioDonutIndicator';
import { RadioIconIndicator } from './components/RadioIconIndicator';
const disabledBackgroundColorByVariant = {
    icon: staticColors.radioDisabled,
    donut: 'transparent',
};
const checkedBackgroundColorByVariant = {
    icon: staticColors.radioChecked,
    donut: 'transparent',
};
const StyledItem = styled(RadixRadioGroup.Item, (p) => {
    const disabledBackgroundColor = disabledBackgroundColorByVariant[p.$indicatorVariant];
    const checkedBackgroundColor = checkedBackgroundColorByVariant[p.$indicatorVariant];
    return {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: sizes.radio.size,
        height: sizes.radio.size,
        flexShrink: 0,
        borderRadius: '50%',
        borderWidth: sizes.radio.borderWidth,
        borderColor: staticColors.radioUnchecked,
        borderStyle: 'solid',
        backgroundColor: p.$isDisabled ? disabledBackgroundColor : 'transparent',
        padding: 0,
        ':hover': {
            backgroundColor: p.$isDisabled ? undefined : staticColors.radioHover,
        },
        ':is([data-state="checked"])': {
            borderColor: p.$isDisabled
                ? staticColors.radioDisabled
                : staticColors.radioChecked,
            backgroundColor: p.$isDisabled
                ? disabledBackgroundColor
                : checkedBackgroundColor,
        },
    };
});
export const RadioItem = ({ value, label: passedLabel, labelElement, underRadio = _jsx(Box, {}), underLabel = _jsx(Box, {}), testId, disabled = false, indicatorVariant = 'icon', }) => {
    const uniqueId = useId();
    const itemId = `${uniqueId}-${value}`;
    const testIdAttribute = useTestIdAttribute(testId);
    const labelTestIdAttribute = useTestIdAttribute(`${testId}-label`);
    const label = labelElement || _jsx(Text, { variant: 's2', children: passedLabel });
    const indicatorsByVariant = {
        icon: (_jsx(RadioIconIndicator, { $isDisabled: disabled, children: _jsx(FlexContainer, { fullHeight: true, fullWidth: true, center: true, children: _jsx(CheckedIcon, {}) }) })),
        donut: _jsx(RadioDonutIndicator, { $isDisabled: disabled }),
    };
    const indicator = indicatorsByVariant[indicatorVariant];
    return (_jsxs(GridContainer, { columns: 'auto 1fr', rows: 'auto 1fr', horizontalAlign: 'center', children: [_jsx(FlexContainer, { spacingRight: true, children: _jsx(StyledItem, { id: itemId, value: value, ...testIdAttribute, $isDisabled: disabled, disabled: disabled, $indicatorVariant: indicatorVariant, children: indicator }) }), _jsx("label", { htmlFor: itemId, ...labelTestIdAttribute, children: label }), underRadio, underLabel] }));
};
